import styled, { css } from "styled-components";
import {customScrollBarStyle, getKeyframes} from "../utils/getKeyframes";
import {borderRadius, borderColor, cardBackground, miniNavbarSize, navbarMinSize, navbarSize, media, primaryColor} from "../utils/variables";
import { Carousel } from 'antd';
import {getCardBackground} from "../utils/getCardBackground";

type FlexAlign = 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around';
type Position = 'sticky' | 'absolute' | 'fixed' | 'relative';

interface LoginAnimation {
  isLoggedIn: boolean;
  isNavOpen: boolean;
}
interface LayoutProps {
  background?: string;
  heightSize?: number;
  widthSize?: string;
  padding?: string;
  between?: number;
  vertical?: boolean;
  fullPage?: boolean;
  centered?: boolean;
  fadeIn?: boolean;
  wrapped?: boolean;
  position?: Position;
  vAlign?: FlexAlign;
  hAlign?: FlexAlign;
  loginAnimation?: LoginAnimation;
  isMacOs?: boolean;
}

export const Layout = styled.div<LayoutProps>`
  display: flex;
  transition: ${({ fullPage }) => (fullPage ? "500ms" : "")};
  max-width: 100vw;
  width: 100%;
  background: ${({ background }) => (background ? background : "unset")};
  height: ${({ heightSize }) => (heightSize ? `${heightSize}px` : "unset")};
  width: ${({ widthSize }) => (widthSize ? `${widthSize}` : "unset")};
  padding: ${({ padding }) => padding ? `${padding}` : '0'};
  position: ${({ position }) => position ? `${position}` : 'unset'};
  gap: ${({ between }) => between ? `${between}px` : `unset`};
  flex-wrap: ${({ wrapped }) => wrapped ? `wrap` : `unset`};
  flex-direction: ${({ vertical }) => vertical ? 'column' : 'row'};

  ${({ fullPage }) => fullPage
    ? css`
        height: 100vh !important;
        width: 100vw;
        
        ${media.mobile} {
          height: 100dvh !important;
        }
        
        ${media.tablet} {
          height: 100dvh !important;
        }
      `
    : ``
  }

  ${({ centered }) => centered
    ? css`
        align-items: center;
        justify-content: center;
      `
    : ``
  }

  ${({ vAlign, vertical }) => vAlign
    ? vertical
      ? `justify-content: ${vAlign};`
      : `align-items: ${vAlign};`
    : ``
  }
  
  ${({ hAlign, vertical }) => hAlign
    ? vertical
      ? `align-items: ${hAlign};`
      : `justify-content: ${hAlign};`
    : ``
  }

  ${({ loginAnimation }) => loginAnimation?.isLoggedIn
    ? css`
        min-width: ${loginAnimation?.isNavOpen
          ? navbarMinSize
          : miniNavbarSize};
        animation: loginNavbarWidth 1s forwards 0.5s;
        > * {
          animation: fadeOut 0.5s forwards;
        }
      `
    : ``
  }

  ${({ fadeIn }) => fadeIn
    ? `
      `
    : ``
  }

  @keyframes loginNavbarWidth {
    to {
      max-width: ${({ loginAnimation }) =>
        loginAnimation?.isNavOpen ? navbarSize : miniNavbarSize};
    }
  }

  ${getKeyframes("fadeIn")}
  ${getKeyframes("fadeOut")}
  
  ${({isMacOs}) => customScrollBarStyle(isMacOs!)}
`;

export const SettingsPageLayout = styled(Layout)<{ $fullHeight?: boolean; $muted?: boolean }>`
  width: 100%;
  background: ${({ $muted }) => ($muted ? 'var(--muted)' : cardBackground)};
  padding: 20px;
  border-radius: ${borderRadius};
  overflow-y: auto;
  ${({ $fullHeight }) =>
    $fullHeight
      ? css`
          flex: 1;
          min-height: 0;
          height: auto;
        `
      : css`
          height: 65vh;
        `}
`;


export const InputLayout = styled(Layout)`
    width: 100%;
    background: ${cardBackground};
    border-radius: ${borderRadius};
    border: 1px solid ${borderColor};
    flex-direction: column;
    gap: 5px;
    padding: 10px;
`

export const WidgetLayout = styled(Layout)`
  width: 160px;
  padding: 10px;
  flex-direction: column;
  gap: 10px;
  min-height: 105px;
  height: fit-content;
  background: var(--muted);
  border-radius: ${borderRadius};
  border: 1px solid ${borderColor};
`

export const CustomCarousel = styled(Carousel)`
  width: 160px;
  max-width: 160px;
  
  .ant-carousel .slick-dots li button {
    background: ${primaryColor};
    width: 12px;       
    height: 12px;
    border-radius: 50%;
  }

  .ant-carousel .slick-dots li.slick-active button {
    background: #52c41a; /* Active dot color */
  }
`

export const Card = styled(Layout)<{
  designID: number | string;
}>`
    height: 60px;
    width: 90px;
    border-radius: 4px;
    padding: 10px;
    flex-direction: column;
    justify-content: space-between;
    align-self: center;
    justify-self: center;
    ${({ designID }) => `background: ${getCardBackground(designID)};`}
`
